export default {"src":"/_next/static/image/public/images/ic_schedule_moon_icon.2ba6b7bad4cade7876d7d32c7a46376f.svg","height":22,"width":16};